import React, { useState, useRef, useCallback, useEffect } from 'react';
import ZoomImageStyled from './bundle.esm2.js';
import Image from '../Image/bundle.esm.js';
import { defaultLensConfig, getCursorPosition } from './bundle.esm3.js';
import { throttle } from '../../utils/bundle.esm5.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ZoomImage = (props) => {
  const _a = props, {
    className,
    lensConfig = defaultLensConfig,
    config,
    width = config == null ? void 0 : config.width,
    height = config == null ? void 0 : config.height
  } = _a, rest = __objRest(_a, [
    "className",
    "lensConfig",
    "config",
    "width",
    "height"
  ]);
  const { zoom = 2 } = lensConfig;
  const [error, setError] = useState(false);
  const lensRef = useRef(null);
  const imageRef = useRef(null);
  const [imgLoading, setImgLoading] = useState(true);
  const imgLoadHandler = (event) => {
    var _a2;
    setImgLoading(false);
    (_a2 = rest == null ? void 0 : rest.onLoad) == null ? void 0 : _a2.call(rest, event);
  };
  const moveLens = useCallback(
    (event) => {
      const lens = lensRef.current;
      const image = imageRef.current;
      if (!lens || !image || error)
        return;
      const cursorPosition = getCursorPosition(event, image);
      const { x: cursorXPosition, y: cursorYPosition } = cursorPosition;
      let newCursorXPosition = cursorXPosition;
      let newCursorYPosition = cursorYPosition;
      let positionLeft = newCursorXPosition - lens.offsetWidth / 2;
      let positionTop = newCursorYPosition - lens.offsetHeight / 2;
      if (positionLeft < 0)
        positionLeft = 0;
      if (positionTop < 0)
        positionTop = 0;
      if (positionLeft > image.width - lens.offsetWidth) {
        positionLeft = image.width - lens.offsetWidth;
      }
      if (positionTop > image.height - lens.offsetHeight) {
        positionTop = image.height - lens.offsetHeight;
      }
      lens.style.left = `${positionLeft}px`;
      lens.style.top = `${positionTop}px`;
      if (cursorXPosition >= image.width - lens.offsetWidth / 2) {
        newCursorXPosition = image.width - lens.offsetWidth / 2;
      }
      if (cursorYPosition > image.height - lens.offsetHeight / 2) {
        newCursorYPosition = image.height - lens.offsetHeight / 2;
      }
      lens.style.backgroundPositionX = `-${newCursorXPosition * zoom}px`;
      lens.style.backgroundPositionY = `-${newCursorYPosition * zoom}px`;
    },
    [error, zoom]
  );
  const zoomImage = () => {
    const lens = lensRef.current;
    const image = imageRef.current;
    if (!lens || !image || error)
      return;
    const { src, width: width2, height: height2 } = image;
    lens.style.backgroundImage = `url(${src})`;
    const backgroundSize = `${width2 * zoom}px ${height2 * zoom}px`;
    lens.style.backgroundSize = backgroundSize;
    lens.style.display = "initial";
  };
  const hideLens = () => {
    if (!lensRef.current)
      return;
    lensRef.current.style.display = "none";
  };
  const mouseOverHandler = () => {
    zoomImage();
  };
  const mouseLeaveHandler = () => {
    hideLens();
  };
  const errorHandler = useCallback(() => {
    hideLens();
    setError(true);
  }, []);
  useEffect(() => {
    const lens = lensRef.current;
    const image = imageRef.current;
    const moveLensThrottled = throttle(moveLens, 25);
    lens == null ? void 0 : lens.addEventListener("mousemove", moveLensThrottled);
    image == null ? void 0 : image.addEventListener("mousemove", moveLensThrottled);
    image == null ? void 0 : image.addEventListener("touchmove", moveLensThrottled);
    image == null ? void 0 : image.addEventListener("error", errorHandler);
    return () => {
      lens == null ? void 0 : lens.removeEventListener("mousemove", moveLensThrottled);
      image == null ? void 0 : image.removeEventListener("mousemove", moveLensThrottled);
      image == null ? void 0 : image.removeEventListener("touchmove", moveLensThrottled);
      image == null ? void 0 : image.removeEventListener("error", errorHandler);
    };
  }, [errorHandler, moveLens]);
  if (!config)
    return null;
  return /* @__PURE__ */ React.createElement(ZoomImageStyled, {
    className: `ZoomImage ${className}`,
    lensConfig,
    width,
    height,
    isLoading: imgLoading,
    onMouseOver: mouseOverHandler,
    onMouseLeave: mouseLeaveHandler,
    onTouchEnd: mouseLeaveHandler
  }, /* @__PURE__ */ React.createElement("div", {
    ref: lensRef,
    className: "ZoomImage__lens"
  }), /* @__PURE__ */ React.createElement(Image, __spreadValues({
    ref: imageRef,
    className: "ZoomImage__image",
    config,
    width,
    height,
    onLoad: imgLoadHandler
  }, rest)));
};
ZoomImage.defaultProps = {
  className: "",
  lensConfig: defaultLensConfig
};

export { ZoomImage as default };
//# sourceMappingURL=bundle.esm.js.map
